const Request = require('./BaseRequest')
const InsightsGraph = require('../graph/InsightsGraph')

module.exports = class InsightsRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new InsightsGraph(this.apiDomain)
    }

    swrTracking(site_id)
    {
        let args = {site_id: site_id}
        let { type, query } = this.graph.trackingQuery(['matomoServer', 'matomo_id', 'ga_id', 'analyticsCode', 'trackingCode'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    swrPixel(accountId, optional={})
    {
        let args = {accountId: accountId, ...optional}
        let { type, query } = this.graph.pixelQuery(['id', 'site_id', 'retargeting_pixel', 'conversion_pixel', 'manychat_pixel','sumo_pixel','onesignal_pixel'], args)
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

    async pixel(accountId, optional={})
    {
        let args = {accountId: accountId, ...optional}
        let { type, query } = this.graph.pixelQuery(['id', 'site_id', 'retargeting_pixel', 'conversion_pixel', 'manychat_pixel','sumo_pixel','onesignal_pixel'], args)
        let data = await this.graph.request(query, args, type, true)
        return data
    }
}